export abstract class Dispose {
	private _disposeCallbacks: (() => void)[] = [];
	readonly appendDisposeCallback = (cb: () => void) => {
		this._disposeCallbacks.push(cb);
	};
	readonly removeDisposeCallback = (cb: () => void) => {
		const idx = this._disposeCallbacks.indexOf(cb);
		if (idx > -1) {
			this._disposeCallbacks.splice(idx, 1);
		}
	};
	readonly dispose = () => {
		for (const cb of this._disposeCallbacks) {
			cb();
		}
	};
}
